// extracted by mini-css-extract-plugin
export default {"cta":"JG-z","disabled":"KG-z"};